import React from "react";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import SuccessMessageModal from "@streeteasy/design-system/legacy/SuccessMessageModal";
import { func, object, shape, string } from "prop-types";

const VerificationSentConfirmation = props => (
  <SuccessMessageModal isOpen onClose={props.handleCloseModal}>
    <SuccessMessageModal.Body>
      <SuccessMessageModal.SuccessIcon />
      <SuccessMessageModal.Title>
        Your message was sent
      </SuccessMessageModal.Title>
      <SuccessMessageModal.Text>
        {props.data.confirmationText}
      </SuccessMessageModal.Text>
    </SuccessMessageModal.Body>
    <SuccessMessageModal.Footer>
      <TextLink
        href="#"
        onClick={e => {
          props.setScenario("VerificationSent", {
            email: props.data.email
          });
          e.preventDefault();
        }}
        theme="primaryTouchedBoldUnderline"
      >
        sign in to access your account
      </TextLink>
    </SuccessMessageModal.Footer>
  </SuccessMessageModal>
);

VerificationSentConfirmation.propTypes = {
  data: shape({
    confirmationText: object.isRequired,
    email: string.isRequired,
    origin: string.isRequired
  }).isRequired,
  handleCloseModal: func.isRequired,
  setScenario: func.isRequired
};

export default VerificationSentConfirmation;
